import { apiRequest } from '../lib/api.js';
import { escapeHtml } from '../lib/html.js';
import { buildHref, isPlainClick } from '../lib/router.js';
import { showToast } from './toast.js';

let sites = [];
let siteId = '';
let aba = 'utms';
let loaded = false;
let loading = false;
let loadError = '';
let opcao = '';
let pixelAberto = false;
let tiktokAberto = false;
let testeLink = '';
let linkEditado = false;
let testePlataforma = 'outra';
let criarAberto = false;
let lojas = [];
let lojaId = '';
const organico = { url: '', source: '', medium: '', campaign: '', content: '', term: '' };
const detalhes = {};
const avisos = {};
const marcacoes = {};
let bound = false;

const ABAS = [
  ['utms', 'UTMs'],
  ['marcacao', 'Marcação'],
  ['pixel', 'Pixel'],
  ['testes', 'Testes'],
];

const ROTULOS = {
  Visitante: 'Visitantes únicos',
  PageView: 'Page view',
  ViewContent: 'Ver conteúdo',
  Search: 'Pesquisa',
  AddToWishlist: 'Lista de desejos',
  AddToCart: 'Add to cart',
  ViewCart: 'Ver carrinho',
  InitiateCheckout: 'Initiate checkout',
  AddPaymentInfo: 'Pagamento',
  Purchase: 'Compra',
  Lead: 'Lead',
  CompleteRegistration: 'Cadastro',
  Contact: 'Contato',
  Subscribe: 'Inscrição',
  CustomizeProduct: 'Personalizar',
  Schedule: 'Agendamento',
  FindLocation: 'Localização',
  SubmitApplication: 'Formulário',
  StartTrial: 'Teste grátis',
};

const TESTE = {
  utm_source: 'FB',
  utm_campaign: 'CampanhaTesteUtms|00000000000000001',
  utm_medium: 'adsetTesteUtms|00000000000000002',
  utm_content: 'ContentTesteUtms|00000000000000003',
  utm_term: 'PlacementTesteUtms',
};

const XCOD_SEP = 'hQwK21wXxR';

async function carregar() {
  loading = true;
  loadError = '';
  try {
    const [data, lojasRes] = await Promise.all([
      apiRequest('/integrations/tracker/sites'),
      apiRequest('/integrations/shopify/lojas').catch(() => null),
    ]);
    sites = data?.data?.sites || [];
    lojas = lojasRes?.data?.lojas || [];
    if (siteId && !sites.some((site) => site.id === siteId)) siteId = '';
    if (!lojas.some((loja) => loja.id === lojaId)) lojaId = lojas[0]?.id || '';
    loaded = true;
  } catch (err) {
    loadError = err.message || 'Não foi possível carregar o rastreamento.';
  } finally {
    loading = false;
  }
}

function siteAtual() {
  return sites.find((site) => site.id === siteId) || null;
}

export function trackerRouteId() {
  return siteId || '';
}

export function aplicarRotaTracker(id) {
  const next = String(id || '');
  if (next === siteId) return;
  siteId = next;
  criarAberto = false;
  opcao = '';
  pixelAberto = false;
  tiktokAberto = false;
  linkEditado = false;
  aplicarLinkPadrao(siteAtual());
}

function copiar(texto) {
  if (!texto) {
    showToast('Nada para copiar.');
    return;
  }
  navigator.clipboard.writeText(texto).then(
    () => showToast('Copiado.'),
    () => showToast('Não foi possível copiar.'),
  );
}

function urlOrganica() {
  const raw = organico.url.trim();
  if (!raw || !organico.source.trim()) return '';
  try {
    const url = new URL(raw.includes('://') ? raw : `https://${raw}`);
    ['source', 'medium', 'campaign', 'content', 'term'].forEach((key) => {
      const value = organico[key].trim();
      if (value) url.searchParams.set(`utm_${key}`, value);
    });
    return url.toString();
  } catch {
    return '';
  }
}

function paginaTesteDoSite(site) {
  const key = site?.publicKey || '';
  if (!key) return '';
  let origin = 'https://tracker.torredecontrole.org';
  const src = String(site.script || '');
  const match = src.match(/src="(https?:\/\/[^"/]+)\/t\.js/);
  if (match) origin = match[1];
  return `${origin}/teste?k=${encodeURIComponent(key)}`;
}

function aplicarLinkPadrao(site) {
  const pagina = paginaTesteDoSite(site);
  if (pagina && !linkEditado) testeLink = pagina;
}

function paginaVisivel(site) {
  const base = paginaTesteDoSite(site);
  if (!base) return '';
  try {
    const url = new URL(base);
    url.searchParams.set('utm_source', 'FB');
    url.searchParams.set('utm_campaign', 'Teste|123');
    url.searchParams.set('utm_medium', 'Conjunto|456');
    url.searchParams.set('utm_content', 'Anuncio|789');
    url.searchParams.set('utm_term', 'feed');
    return url.toString();
  } catch {
    return base;
  }
}

function linkTeste() {
  const raw = testeLink.trim();
  if (!raw) return '';
  try {
    const url = new URL(raw.includes('://') ? raw : `https://${raw}`);
    Object.entries(TESTE).forEach(([key, value]) => url.searchParams.set(key, value));
    if (testePlataforma === 'hotmart') {
      url.searchParams.set('xcod', ['FB', TESTE.utm_campaign, TESTE.utm_medium, TESTE.utm_content, TESTE.utm_term].join(XCOD_SEP));
    }
    return url.toString();
  } catch {
    return '';
  }
}

function abasHtml() {
  return `<div class="fat-toggle" role="tablist" aria-label="Rastreamento">
    ${ABAS.map(([id, label]) => `<button type="button" class="pill-btn ${aba === id ? 'on' : ''}" data-tracker="aba" data-v="${id}" aria-selected="${aba === id}">${label}</button>`).join('')}
  </div>`;
}

function dominiosDo(site) {
  return site.dominios?.length ? site.dominios : [site.dominio].filter(Boolean);
}

function chaveCurta(key) {
  const value = String(key || '');
  if (!value) return '—';
  if (value.length <= 16) return value;
  return `${value.slice(0, 8)}…${value.slice(-4)}`;
}

function pixelResumo(site) {
  const fb = site.facebook;
  if (!fb?.pixelId) {
    return { classe: 'pill-neutral', pill: 'Sem pixel', valor: '—', detalhe: 'ID e token ainda não salvos' };
  }
  return {
    classe: fb.ativo === false ? 'pill-amber' : 'pill-green',
    pill: fb.ativo === false ? 'Pixel pausado' : 'Pixel ativo',
    valor: fb.pixelId,
    detalhe: [
      fb.tokenSalvo ? 'Token salvo' : 'Sem token',
      fb.testEventCode ? `Teste ${fb.testEventCode}` : 'Sem código de teste',
    ].join(' · '),
  };
}

function shopifyResumo(site) {
  const shop = site.shopify;
  if (!shop?.shopDomain && !shop?.produtos) {
    return { classe: 'pill-neutral', pill: 'Sem Shopify', valor: '—', detalhe: 'Script ainda não instalado na loja' };
  }
  const completo = Boolean(shop.produtos && shop.checkout);
  return {
    classe: completo ? 'pill-green' : 'pill-amber',
    pill: completo ? 'Shopify instalada' : 'Shopify parcial',
    valor: shop.shopDomain || 'Loja conectada',
    detalhe: completo ? 'Produtos e checkout' : (shop.produtos ? 'Produtos instalados · checkout pendente' : 'Instalação incompleta'),
  };
}

function fatoHtml(rotulo, valor, detalhe) {
  return `<div class="store-metric">
    <div class="lbl">${escapeHtml(rotulo)}</div>
    <div class="val" title="${escapeHtml(valor)}">${escapeHtml(valor)}</div>
    <div class="cell-sub">${escapeHtml(detalhe)}</div>
  </div>`;
}

function listaHtml() {
  const linhas = sites.length
    ? sites.map((site) => {
      const dominios = dominiosDo(site);
      const pixel = pixelResumo(site);
      const shopify = shopifyResumo(site);
      return `<a class="g-card trk-card" href="${buildHref({ section: 'tracker', trackerId: site.id })}" data-tracker="abrir-site" data-id="${escapeHtml(site.id)}">
        <div class="trk-card-top">
          <div class="store-card-copy">
            <div class="cell-title">${escapeHtml(site.nome)}</div>
            <div class="cell-sub">${escapeHtml(dominios.join(' · ') || 'Sem domínio')}</div>
          </div>
          <span class="trk-abrir">Abrir</span>
        </div>
        <div class="store-card-pills">
          <span class="pill pill-neutral">${dominios.length} ${dominios.length === 1 ? 'domínio' : 'domínios'}</span>
          <span class="pill ${pixel.classe}">${escapeHtml(pixel.pill)}</span>
          <span class="pill ${shopify.classe}">${escapeHtml(shopify.pill)}</span>
        </div>
        <div class="trk-facts">
          ${fatoHtml('Domínios', String(dominios.length), dominios.join(' · ') || 'Nenhum')}
          ${fatoHtml('Pixel', pixel.valor, pixel.detalhe)}
          ${fatoHtml('Shopify', shopify.valor, shopify.detalhe)}
          ${fatoHtml('Chave', chaveCurta(site.publicKey), site.publicKey ? 'Identifica o script deste rastreamento' : 'Sem chave')}
        </div>
      </a>`;
    }).join('')
    : '<p class="cell-sub">Nenhum rastreamento ainda.</p>';
  const form = (criarAberto || !sites.length)
    ? `<div style="margin:12px 0 16px"><p class="cell-sub">Cada rastreamento tem o próprio script. Escolha a loja Shopify para instalar esse script nela.</p>${formularioSite()}</div>`
    : '';
  return `<section class="g-card trk-shell">
    <div class="trk-list-bar">
      <h3 class="card-title">Rastreamentos</h3>
      <button type="button" class="btn btn-primary" data-tracker="novo">${criarAberto ? 'Fechar' : 'Novo rastreamento'}</button>
    </div>
    ${form}
    <div class="trk-list">${linhas}</div>
  </section>`;
}

function cabecalhoDetalhe(site) {
  const pixel = pixelResumo(site);
  const shopify = shopifyResumo(site);
  return `<div class="trk-head">
    <a class="trk-back" href="${buildHref({ section: 'tracker' })}" data-tracker="lista">← Rastreamentos</a>
    <div class="trk-head-copy">
      <div class="cell-title">${escapeHtml(site.nome)}</div>
      <div class="cell-sub">${escapeHtml(dominiosDo(site).join(' · ') || 'Sem domínio')}</div>
    </div>
    <div class="trk-head-side">
      <span class="pill ${pixel.classe}">${escapeHtml(pixel.pill)}</span>
      <span class="pill ${shopify.classe}">${escapeHtml(shopify.pill)}</span>
      <button type="button" class="btn btn-ghost" data-tracker="apagar" data-id="${escapeHtml(site.id)}">Remover</button>
    </div>
  </div>`;
}

function formularioSite() {
  const opcoes = lojas.map((loja) => `<option value="${escapeHtml(loja.id)}" ${loja.id === lojaId ? 'selected' : ''}>${escapeHtml(loja.nome || loja.shop_domain || 'Loja')} · ${escapeHtml(loja.shop_domain || '')}</option>`).join('');
  const loja = lojas.length
    ? `<div class="field"><label>Loja Shopify</label><select name="lojaId" data-tracker="loja"><option value="">Nenhuma</option>${opcoes}</select></div>`
    : `<div class="field"><label>Loja Shopify</label><p class="cell-sub">Nenhuma loja conectada. Conecte em Lojas para instalar o script direto.</p></div>`;
  return `
    <form class="trk-form" data-tracker="criar">
      <div class="field"><label>Nome</label><input name="nome" required placeholder="Loja principal"></div>
      <div class="field"><label>Domínio</label><input name="dominio" required placeholder="loja.com.br"></div>
      ${loja}
      <button type="submit" class="btn btn-primary">Gerar script</button>
    </form>`;
}

function lojaDoSite(site) {
  const salva = site?.shopify?.lojaId;
  if (salva && lojas.some((loja) => loja.id === salva)) return salva;
  return lojaId;
}

function opcoesLoja(selecionada) {
  return lojas.map((loja) => `<option value="${escapeHtml(loja.id)}" ${loja.id === selecionada ? 'selected' : ''}>${escapeHtml(loja.nome || loja.shop_domain || 'Loja')} · ${escapeHtml(loja.shop_domain || '')}</option>`).join('');
}

function cardDominios(site) {
  const dominios = dominiosDo(site);
  const lista = dominios.map((dominio) => `<li class="trk-domain"><b>${escapeHtml(dominio)}</b>${dominios.length > 1 ? `<button type="button" class="btn btn-ghost" data-tracker="remover-dominio" data-id="${escapeHtml(site.id)}" data-dominio="${escapeHtml(dominio)}">Remover</button>` : ''}</li>`).join('');
  return `<section class="g-card trk-pad">
    <div class="card-head">
      <h3 class="card-title">Domínios</h3>
      <span class="card-meta">${dominios.length} ${dominios.length === 1 ? 'domínio' : 'domínios'}</span>
    </div>
    <p class="cell-sub">Cada domínio tem o próprio script. Ele também aceita os outros domínios deste rastreamento.</p>
    <ul class="trk-domains">${lista}</ul>
    <form class="trk-form" data-tracker="dominio" data-id="${escapeHtml(site.id)}">
      <div class="field"><label>Outro domínio</label><input name="dominio" required placeholder="outro.com.br"></div>
      <button type="submit" class="btn btn-primary">Adicionar</button>
    </form>
  </section>`;
}

function cardShopify(site) {
  const shopify = site.shopify;
  const resumo = shopifyResumo(site);
  const selecionada = lojaDoSite(site);
  const status = shopify
    ? `<ul class="trk-status">
        <li><span class="pill ${shopify.produtos ? 'pill-green' : 'pill-amber'}">${shopify.produtos ? 'ok' : 'falta'}</span><span>Produtos</span><small>${shopify.produtos ? 'script instalado' : 'ainda sem o script'}</small></li>
        <li><span class="pill ${shopify.checkout ? 'pill-green' : 'pill-amber'}">${shopify.checkout ? 'ok' : 'falta'}</span><span>Checkout</span><small>${shopify.checkout ? 'script instalado' : escapeHtml(shopify.checkoutErro || 'ainda sem o script')}</small></li>
      </ul>`
    : '<p class="trk-note">O script ainda não foi instalado nesta loja.</p>';
  const acao = lojas.length
    ? `<div class="trk-install">
        <div class="field"><label>Loja</label><select data-tracker="loja">${opcoesLoja(selecionada)}</select></div>
        <button type="button" class="btn btn-primary" data-tracker="shopify" data-id="${escapeHtml(site.id)}">Instalar na Shopify</button>
      </div>`
    : '<p class="trk-note">Conecte uma loja em Lojas para instalar o script direto.</p>';
  return `<section class="g-card trk-pad">
    <div class="card-head">
      <div>
        <h3 class="card-title">Shopify</h3>
        ${shopify?.shopDomain ? `<p class="cell-sub">${escapeHtml(shopify.shopDomain)}</p>` : ''}
      </div>
      <span class="pill ${resumo.classe}">${escapeHtml(resumo.pill)}</span>
    </div>
    <p class="cell-sub">Instala o script de marcação nas páginas de produto e no checkout.</p>
    ${status}
    ${acao}
  </section>`;
}

function scriptsDo(site) {
  if (site?.scripts?.length) return site.scripts;
  return [{ dominio: site?.dominio || 'Site', script: site?.script || '' }];
}

function painelUtms(site) {
  const gerada = urlOrganica();
  const blocos = scriptsDo(site).map((item) => `<div class="trk-domain"><b>${escapeHtml(item.dominio || 'Domínio')}</b><button type="button" class="btn btn-primary" data-tracker="copiar" data-text="${escapeHtml(item.script || '')}">Copiar</button></div><pre class="trk-code">${escapeHtml(item.script || '')}</pre>`).join('');
  return `<div class="trk-stack">
    <section class="g-card trk-pad">
      <div class="card-head">
        <div class="trk-row-copy">
          <h3 class="card-title">Script de marcação</h3>
          <p class="cell-sub">Cole no <b>&lt;head&gt;</b> de cada domínio, antes de <b>&lt;/head&gt;</b>. Marca page view, ver conteúdo, add to cart, initiate checkout, compra e os outros eventos do pixel, e continua guardando as UTMs.</p>
        </div>
      </div>
      ${blocos}
      <p class="trk-note">No botão ou formulário, use <b>data-tc="AddToCart"</b>, <b>data-tc="InitiateCheckout"</b> ou <b>data-tc="Purchase"</b>. Valor opcional: <b>data-tc-value</b> e <b>data-tc-currency</b>. No JavaScript: <b>tcTracker.evento('Purchase', { value: 97, currency: 'BRL' })</b>.</p>
    </section>
    <div class="trk-split">
      ${cardDominios(site)}
      ${cardShopify(site)}
    </div>
    <section class="g-card trk-pad">
      <h3 class="card-title">Gerar UTMs orgânicas</h3>
      <p class="cell-sub">Monte um link com origem, meio e campanha para o tráfego que não vem de anúncio.</p>
      <div class="trk-org">
        <div class="field"><label>Link da URL</label><input data-org="url" value="${escapeHtml(organico.url)}" placeholder="https://seusite.com"></div>
        <div class="trk-org-row trk-org-2">
          <div class="field"><label>utm_source (Origem)</label><input data-org="source" value="${escapeHtml(organico.source)}" placeholder="bio"></div>
          <div class="field"><label>utm_medium (Meio)</label><input data-org="medium" value="${escapeHtml(organico.medium)}" placeholder="instagram"></div>
        </div>
        <div class="trk-org-row trk-org-3">
          <div class="field"><label>utm_campaign (Campanha)</label><input data-org="campaign" value="${escapeHtml(organico.campaign)}" placeholder="perfil"></div>
          <div class="field"><label>utm_content (Conteúdo)</label><input data-org="content" value="${escapeHtml(organico.content)}" placeholder="link-bio"></div>
          <div class="field"><label>utm_term (Termo)</label><input data-org="term" value="${escapeHtml(organico.term)}" placeholder="promo"></div>
        </div>
        <div class="trk-actions">
          <button type="button" class="btn btn-primary" data-tracker="gerar">Gerar URL</button>
          <input data-tracker="url-organica" readonly value="${escapeHtml(gerada)}" placeholder="A URL gerada aparecerá aqui">
          ${gerada ? `<button type="button" class="btn" data-tracker="copiar" data-text="${escapeHtml(gerada)}">Copiar URL</button>` : ''}
        </div>
      </div>
    </section>
  </div>`;
}

function painelPixel(site) {
  if (!site) {
    return `
      <section class="g-card" style="padding:16px 18px">
        <h3 class="card-title">Pixels</h3>
        <p class="cell-sub">Utilize o pixel para aumentar a inteligência das campanhas.</p>
        <p class="cell-sub">Gere o script na aba UTMs para cadastrar o pixel deste site.</p>
      </section>`;
  }
  const fb = site.facebook || {};
  const pronto = Boolean(fb.pixelId && fb.tokenSalvo);
  if (!pixelAberto && !pronto) {
    return `
      <section class="g-card" style="padding:16px 18px">
        <h3 class="card-title">Pixels</h3>
        <p class="cell-sub">Utilize o pixel para aumentar a inteligência das campanhas.</p>
        <button type="button" class="btn btn-primary" data-tracker="pixel-abrir" style="margin-top:12px">Adicionar Pixel</button>
      </section>`;
  }
  if (!pixelAberto) {
    return `
      <section class="g-card" style="padding:16px 18px">
        <div class="card-head">
          <h3 class="card-title">Pixels</h3>
          <button type="button" class="btn btn-primary" data-tracker="pixel-abrir">Editar</button>
        </div>
        <div class="trk-row">
          <div>
            <div class="cell-title">Meta (Facebook)</div>
            <div class="cell-sub">ID ${escapeHtml(fb.pixelId)}${fb.tokenSalvo ? ` · token ••${escapeHtml(fb.tokenFim || '')}` : ''}</div>
          </div>
          <span class="pill pill-green">configurado</span>
        </div>
        <p class="cell-sub">O script da aba UTMs dispara este pixel.</p>
      </section>`;
  }
  return `
    <section class="g-card" style="padding:16px 18px">
      <div class="card-head">
        <h3 class="card-title">${pronto ? 'Editar pixel' : 'Adicionar Pixel'}</h3>
        <button type="button" class="btn btn-ghost" data-tracker="pixel-fechar">Fechar</button>
      </div>
      <p class="cell-sub">Tipo de pixel: Meta (Facebook). O script da aba UTMs dispara este pixel.</p>
      <form data-tracker="pixel" data-id="${escapeHtml(site.id)}" style="display:flex;flex-direction:column;gap:12px;margin-top:12px">
        <div class="field-row">
          <div class="field"><label>ID do pixel</label><input name="pixelId" inputmode="numeric" value="${escapeHtml(fb.pixelId || '')}" placeholder="1342429849238924" required></div>
          <div class="field"><label>Código de teste</label><input name="testEventCode" value="${escapeHtml(fb.testEventCode || '')}" placeholder="TEST12345"></div>
        </div>
        ${fb.tokenSalvo ? `
        <label class="cell-sub" style="display:flex;gap:8px;align-items:center">
          <input type="checkbox" data-tracker="alterar-token">
          Alterar credenciais · token salvo (••${escapeHtml(fb.tokenFim || '')})
        </label>
        <div class="field" data-tracker="token-campo" hidden>
          <label>Token da API de Conversões</label>
          <input name="accessToken" type="password" autocomplete="new-password" placeholder="Novo token" disabled>
        </div>` : `
        <div class="field">
          <label>Token da API de Conversões</label>
          <input name="accessToken" type="password" autocomplete="new-password" placeholder="Token da API de Conversões" required>
        </div>`}
        <div><button type="submit" class="btn btn-primary">Salvar Dados</button></div>
      </form>
    </section>`;
}

function blocoTikTok(site) {
  if (!site) return '';
  const tt = site.tiktok || {};
  if (!tiktokAberto && !tt.pixelId) {
    return `<section class="g-card trk-pad">
      <h3 class="card-title">TikTok</h3>
      <p class="cell-sub">O mesmo script dispara o pixel do TikTok junto com o da Meta.</p>
      <button type="button" class="btn btn-primary" data-tracker="tiktok-abrir" style="margin-top:12px">Adicionar pixel do TikTok</button>
    </section>`;
  }
  if (!tiktokAberto) {
    return `<section class="g-card trk-pad">
      <div class="card-head">
        <h3 class="card-title">TikTok</h3>
        <button type="button" class="btn btn-primary" data-tracker="tiktok-abrir">Editar</button>
      </div>
      <div class="trk-row">
        <div>
          <div class="cell-title">Pixel ${escapeHtml(tt.pixelId)}</div>
          <div class="cell-sub">${tt.tokenSalvo ? `Token ••${escapeHtml(tt.tokenFim || '')} · envio pelo servidor` : 'Só no navegador, sem token de servidor'}</div>
        </div>
        <span class="pill pill-green">configurado</span>
      </div>
    </section>`;
  }
  return `<section class="g-card trk-pad">
    <div class="card-head">
      <h3 class="card-title">${tt.pixelId ? 'Editar TikTok' : 'Pixel do TikTok'}</h3>
      <button type="button" class="btn btn-ghost" data-tracker="tiktok-fechar">Fechar</button>
    </div>
    <p class="cell-sub">Sem token, o pixel dispara no navegador. Com token, a Torre também envia o evento pelo servidor. Deixe o ID em branco para remover.</p>
    <form data-tracker="tiktok" data-id="${escapeHtml(site.id)}" style="display:flex;flex-direction:column;gap:12px;margin-top:12px">
      <div class="field"><label>ID do pixel</label><input name="pixelId" value="${escapeHtml(tt.pixelId || '')}" placeholder="D1A2B3C4D5E6"></div>
      ${tt.tokenSalvo ? `
      <label class="cell-sub" style="display:flex;gap:8px;align-items:center">
        <input type="checkbox" data-tracker="alterar-token">
        Alterar token · salvo (••${escapeHtml(tt.tokenFim || '')})
      </label>
      <div class="field" data-tracker="token-campo" hidden>
        <label>Access token</label>
        <input name="accessToken" type="password" autocomplete="new-password" placeholder="Novo token" disabled>
      </div>` : `
      <div class="field">
        <label>Access token (opcional)</label>
        <input name="accessToken" type="password" autocomplete="new-password" placeholder="Token da Events API">
      </div>`}
      <div><button type="submit" class="btn btn-primary">Salvar Dados</button></div>
    </form>
  </section>`;
}

function numero(valor) {
  return new Intl.NumberFormat('pt-BR').format(Number(valor) || 0);
}

function dinheiro(centavos) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format((Number(centavos) || 0) / 100);
}

function diaCurto(iso) {
  const [ano, mes, dia] = String(iso || '').split('-');
  if (!dia || !mes) return iso || '';
  return `${dia}/${mes}${ano ? `/${ano.slice(2)}` : ''}`;
}

function somarEvento(linhas, evento, dia) {
  return linhas.reduce((acc, linha) => {
    if (linha.evento !== evento || linha.dominio === 'teste') return acc;
    if (dia && linha.dia !== dia) return acc;
    acc.total += Number(linha.total) || 0;
    acc.unicos += Number(linha.unicos) || 0;
    acc.valor += Number(linha.valor) || 0;
    return acc;
  }, { total: 0, unicos: 0, valor: 0 });
}

function diasResumo(linhas) {
  const mapa = new Map();
  for (const linha of linhas) {
    if (linha.dominio === 'teste') continue;
    const item = mapa.get(linha.dia) || { dia: linha.dia, page: 0, unicos: 0, cart: 0, checkout: 0, compra: 0, valor: 0 };
    if (linha.evento === 'PageView') item.page += Number(linha.total) || 0;
    if (linha.evento === 'Visitante') item.unicos += Number(linha.unicos) || 0;
    if (linha.evento === 'AddToCart') item.cart += Number(linha.total) || 0;
    if (linha.evento === 'InitiateCheckout') item.checkout += Number(linha.total) || 0;
    if (linha.evento === 'Purchase') {
      item.compra += Number(linha.total) || 0;
      item.valor += Number(linha.valor) || 0;
    }
    mapa.set(linha.dia, item);
  }
  return [...mapa.values()].sort((a, b) => (a.dia < b.dia ? 1 : -1));
}

function painelMarcacao(site) {
  const dados = marcacoes[site.id];
  if (!dados) {
    return `<section class="g-card trk-pad"><h3 class="card-title">Marcação</h3><p class="cell-sub">Carregando estatísticas…</p></section>`;
  }
  const linhas = dados.linhas || [];
  const hoje = dados.hoje || '';
  const cards = [
    ['Visitante', 'Visitantes únicos'],
    ['PageView', 'Page view'],
    ['ViewContent', 'Ver conteúdo'],
    ['AddToCart', 'Add to cart'],
    ['InitiateCheckout', 'Initiate checkout'],
    ['Purchase', 'Compra'],
  ].map(([evento, rotulo]) => {
    const item = somarEvento(linhas, evento, hoje);
    const detalhe = evento === 'Purchase' && item.valor
      ? `${dinheiro(item.valor)} · ${numero(item.unicos)} únicos`
      : `${numero(item.unicos)} únicos`;
    return fatoHtml(rotulo, evento === 'Visitante' ? numero(item.unicos) : numero(item.total), detalhe);
  }).join('');
  const dias = diasResumo(linhas);
  const tabela = dias.length
    ? `<div class="trk-stats-wrap"><table class="trk-stats"><thead><tr><th>Dia</th><th>Visitantes</th><th>Page view</th><th>Carrinho</th><th>Checkout</th><th>Compras</th><th>Valor</th></tr></thead><tbody>${dias.map((dia) => `<tr><td>${escapeHtml(diaCurto(dia.dia))}</td><td>${numero(dia.unicos)}</td><td>${numero(dia.page)}</td><td>${numero(dia.cart)}</td><td>${numero(dia.checkout)}</td><td>${numero(dia.compra)}</td><td>${dinheiro(dia.valor)}</td></tr>`).join('')}</tbody></table></div>`
    : '<p class="trk-note">Nenhuma marcação ainda. Cole o script da aba UTMs no site.</p>';
  const outros = linhas.filter((linha) => linha.dia === hoje && linha.dominio !== 'teste' && !['Visitante', 'PageView', 'ViewContent', 'AddToCart', 'InitiateCheckout', 'Purchase'].includes(linha.evento) && linha.total > 0);
  const extra = outros.length
    ? `<ul class="trk-domains">${outros.map((linha) => `<li class="trk-domain"><b>${escapeHtml(ROTULOS[linha.evento] || linha.evento)}</b><span>${numero(linha.total)} · ${numero(linha.unicos)} únicos</span></li>`).join('')}</ul>`
    : '';
  const avisoTabela = dados.tabela === false
    ? '<p class="trk-note">O contador já está recebendo os eventos. A tabela de estatísticas no banco ainda precisa da migração para fechar o acumulado.</p>'
    : '';
  return `<div class="trk-stack">
    <section class="g-card trk-pad">
      <div class="card-head">
        <div>
          <h3 class="card-title">Hoje</h3>
          <p class="cell-sub">Cada visita entra num contador. A cada 1 minuto o total fecha no banco. Visitante único é a primeira marcação do dia, no cookie do navegador.</p>
        </div>
        <button type="button" class="btn" data-tracker="atualizar-marcacao" data-id="${escapeHtml(site.id)}">Atualizar</button>
      </div>
      ${avisoTabela}
      <div class="trk-facts" style="margin-top:14px">${cards}</div>
      ${extra}
    </section>
    <section class="g-card trk-pad">
      <h3 class="card-title">Últimos dias</h3>
      ${tabela}
    </section>
  </div>`;
}

function painelTestes(site) {
  aplicarLinkPadrao(site);
  const det = site ? detalhes[site.id] : null;
  const eventos = det?.eventos || [];
  const marcadores = det?.marcadores;
  const listaMarcadores = marcadores
    ? marcadores.itens.map((item) => `<li><span class="pill ${item.ok ? 'pill-green' : 'pill-amber'}">${item.ok ? 'ok' : 'falta'}</span> ${escapeHtml(item.label)} <span class="cell-sub">${escapeHtml(item.valor || item.esperado)}</span></li>`).join('')
    : '';
  const listaTestes = eventos.length
    ? eventos.slice(0, 8).map((evento) => `<li><span class="cell-title">${escapeHtml(evento.nome || 'evento')}</span> <span class="cell-sub">${escapeHtml(String(evento.created_at || '').replace('T', ' ').slice(0, 19))}</span></li>`).join('')
    : '<li class="cell-sub">Nenhum teste realizado ainda</li>';
  const pronto = Boolean(linkTeste());
  const visivel = paginaVisivel(site);
  const preview = visivel ? `
    <section class="g-card" style="padding:16px 18px;margin-bottom:16px">
      <h3 class="card-title">Página de teste</h3>
      <p class="cell-sub">Página da Torre para testar o script sem publicar no site. Copie o endereço para mandar.</p>
      <a href="${escapeHtml(visivel)}" target="_blank" rel="noopener" style="display:block;margin:10px 0 12px;word-break:break-all;color:var(--accent-2)">${escapeHtml(visivel)}</a>
      <div class="trk-actions">
        <button type="button" class="btn btn-primary" data-tracker="copiar" data-text="${escapeHtml(visivel)}">Copiar</button>
        <a class="btn" href="${escapeHtml(visivel)}" target="_blank" rel="noopener">Abrir</a>
      </div>
      <iframe class="trk-preview" src="${escapeHtml(visivel)}" title="Página de teste"></iframe>
    </section>` : '';
  return `
    ${preview}
    <div class="trk-grid">
      <section class="g-card" style="padding:16px 18px">
        <h3 class="card-title">Teste a integração</h3>
        <p class="cell-sub">É importante que o link de teste seja o mesmo que vai na campanha. Se tiver cloaker, use o link do cloaker.</p>
        <p class="cell-sub"><b>Como testar:</b> copie o link e siga do início do funil até o checkout. A visita aparece em Últimos testes.</p>
        <div class="field-row" style="margin-top:12px">
          <div class="field">
            <label>Fonte de tráfego</label>
            <input value="Meta (Facebook)" readonly>
          </div>
          <div class="field">
            <label>Plataforma</label>
            <select data-tracker="plataforma">
              <option value="outra" ${testePlataforma === 'outra' ? 'selected' : ''}>Outra</option>
              <option value="hotmart" ${testePlataforma === 'hotmart' ? 'selected' : ''}>Hotmart</option>
            </select>
          </div>
        </div>
        <div class="field" style="margin-top:10px">
          <label>Link</label>
          <input data-tracker="teste-link" value="${escapeHtml(testeLink)}" placeholder="Cole o link da campanha, se o teste não for na página da Torre">
        </div>
        <div style="display:flex;gap:8px;margin-top:12px">
          <button type="button" class="btn btn-primary" data-tracker="copiar-teste" ${pronto ? '' : 'disabled'}>Copiar</button>
          <button type="button" class="btn" data-tracker="abrir-teste" ${pronto ? '' : 'disabled'}>Testar</button>
        </div>
        ${site && avisos[site.id] ? `<p class="cell-sub" style="margin-top:10px">${escapeHtml(avisos[site.id])}</p>` : ''}
        ${site ? `<div style="margin-top:16px">
          <button type="button" class="btn" data-tracker="testar" data-id="${escapeHtml(site.id)}">Enviar evento de teste do pixel</button>
          <p class="cell-sub">Usa o código de teste salvo na aba Pixel. O evento aparece em Gerenciador de Eventos → Testar eventos.</p>
        </div>` : ''}
      </section>
      <section class="g-card" style="padding:16px 18px">
        <div class="card-head">
          <h3 class="card-title">Últimos testes</h3>
          ${site ? `<button type="button" class="btn" data-tracker="validar" data-id="${escapeHtml(site.id)}">Atualizar</button>` : ''}
        </div>
        <ul class="side-list">${listaTestes}</ul>
        ${listaMarcadores ? `<ul style="list-style:none;padding:0;margin:12px 0 0;display:flex;flex-direction:column;gap:8px">${listaMarcadores}</ul>` : ''}
      </section>
    </div>`;
}

export function renderTracker() {
  if (!loaded && !loading && !loadError) {
    loading = true;
    carregar().then(() => document.dispatchEvent(new CustomEvent('torre:tracker-ready')));
  }
  if (!loaded) {
    return `<div class="empty-state">${loadError ? escapeHtml(loadError) : 'Carregando rastreamento…'}</div>`;
  }
  const site = siteAtual();
  if (!site) return `<div class="trk-page">${listaHtml()}</div>`;
  const corpo = aba === 'pixel'
    ? `<div class="trk-stack">${painelPixel(site)}${blocoTikTok(site)}</div>`
    : aba === 'testes'
      ? painelTestes(site)
      : aba === 'marcacao'
        ? painelMarcacao(site)
        : painelUtms(site);
  return `<div class="trk-page">${cabecalhoDetalhe(site)}${abasHtml()}${corpo}</div>`;
}

async function carregarMarcacao(id) {
  const data = await apiRequest(`/integrations/tracker/sites/${encodeURIComponent(id)}/marcacao`);
  marcacoes[id] = data?.data || { linhas: [], hoje: '', tabela: true };
}

async function validar(id) {
  const data = await apiRequest(`/integrations/tracker/sites/${encodeURIComponent(id)}/eventos`);
  detalhes[id] = data?.data || {};
  showToast(detalhes[id].marcadores?.ok ? 'UTMs do Facebook chegaram completas.' : 'Atualizado. Veja o que ainda falta.');
}

export function bindTracker(onChange) {
  if (bound) return;
  bound = true;
  document.addEventListener('torre:tracker-ready', () => onChange?.());
  const root = document.getElementById('content');
  root.addEventListener('input', (event) => {
    const org = event.target.closest('[data-org]');
    if (org) organico[org.dataset.org] = org.value;
    if (event.target.matches('[data-tracker="teste-link"]')) {
      testeLink = event.target.value;
      linkEditado = testeLink.trim() !== paginaTesteDoSite(siteAtual());
      const ok = Boolean(linkTeste());
      root.querySelectorAll('[data-tracker="copiar-teste"], [data-tracker="abrir-teste"]').forEach((botao) => { botao.disabled = !ok; });
    }
  });
  root.addEventListener('change', (event) => {
    const alterar = event.target.closest('[data-tracker="alterar-token"]');
    if (alterar) {
      const campo = alterar.closest('form')?.querySelector('[data-tracker="token-campo"]');
      const input = campo?.querySelector('input');
      if (campo) campo.hidden = !alterar.checked;
      if (input) {
        input.disabled = !alterar.checked;
        input.required = alterar.checked;
        if (!alterar.checked) input.value = '';
      }
      return;
    }
    const loja = event.target.closest('[data-tracker="loja"]');
    if (loja) {
      lojaId = loja.value;
      return;
    }
    const select = event.target.closest('[data-tracker="site"]');
    if (select) {
      siteId = select.value;
      opcao = '';
      pixelAberto = false;
      tiktokAberto = false;
      linkEditado = false;
      aplicarLinkPadrao(siteAtual());
      onChange?.();
      return;
    }
    const plataforma = event.target.closest('[data-tracker="plataforma"]');
    if (plataforma) {
      testePlataforma = plataforma.value;
      onChange?.();
    }
  });
  root.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-tracker]');
    if (!btn || btn.dataset.tracker === 'pixel' || btn.dataset.tracker === 'criar' || btn.dataset.tracker === 'site') return;
    const acao = btn.dataset.tracker;
    if (acao === 'abrir-site' || acao === 'lista') {
      if (btn.tagName === 'A' && !isPlainClick(event)) return;
      if (btn.tagName === 'A') event.preventDefault();
      aplicarRotaTracker(acao === 'lista' ? '' : (btn.dataset.id || ''));
      onChange?.();
      return;
    }
    if (acao === 'novo') {
      criarAberto = !criarAberto;
      onChange?.();
      return;
    }
    if (acao === 'aba') {
      aba = btn.dataset.v || 'utms';
      onChange?.();
      if (aba === 'testes' && siteId && !detalhes[siteId]) validar(siteId).then(() => onChange?.()).catch(() => {});
      if (aba === 'marcacao' && siteId) carregarMarcacao(siteId).then(() => onChange?.()).catch((err) => showToast(err.message || 'Não foi possível carregar a marcação.'));
      return;
    }
    if (acao === 'opcao') {
      opcao = opcao === btn.dataset.v ? '' : (btn.dataset.v || '');
      onChange?.();
      return;
    }
    if (acao === 'pixel-abrir') {
      pixelAberto = true;
      onChange?.();
      return;
    }
    if (acao === 'pixel-fechar') {
      pixelAberto = false;
      onChange?.();
      return;
    }
    if (acao === 'tiktok-abrir') {
      tiktokAberto = true;
      onChange?.();
      return;
    }
    if (acao === 'tiktok-fechar') {
      tiktokAberto = false;
      onChange?.();
      return;
    }
    if (acao === 'atualizar-marcacao') {
      btn.disabled = true;
      try {
        await carregarMarcacao(btn.dataset.id || siteId);
        onChange?.();
      } catch (err) {
        showToast(err.message || 'Não foi possível atualizar.');
      } finally {
        btn.disabled = false;
      }
      return;
    }
    if (acao === 'gerar') {
      const gerada = urlOrganica();
      if (!gerada) showToast('Informe o link e a origem.');
      onChange?.();
      return;
    }
    if (acao === 'copiar') {
      copiar(btn.dataset.text || '');
      return;
    }
    if (acao === 'copiar-teste') {
      copiar(linkTeste());
      return;
    }
    if (acao === 'abrir-teste') {
      const url = linkTeste();
      if (!url) return;
      window.open(url, '_blank', 'noopener');
      return;
    }
    const id = btn.dataset.id;
    if (acao === 'remover-dominio') {
      try {
        await apiRequest(`/integrations/tracker/sites/${encodeURIComponent(id)}`, {
          method: 'PATCH',
          body: JSON.stringify({ removerDominio: btn.dataset.dominio || '' }),
        });
        await carregar();
        onChange?.();
      } catch (err) {
        showToast(err.message || 'Não foi possível remover o domínio.');
      }
      return;
    }
    if (acao === 'shopify') {
      const escolhida = root.querySelector('[data-tracker="loja"]')?.value || lojaId;
      if (!escolhida) {
        showToast('Escolha a loja.');
        return;
      }
      btn.disabled = true;
      try {
        const res = await apiRequest(`/integrations/tracker/sites/${encodeURIComponent(id)}/shopify`, {
          method: 'POST',
          body: JSON.stringify({ lojaId: escolhida }),
        });
        const info = res?.data || {};
        showToast(info.checkout ? 'Script instalado nos produtos e no checkout.' : 'Script instalado nos produtos. O checkout pediu reconectar a Shopify.');
        await carregar();
        onChange?.();
      } catch (err) {
        showToast(err.message || 'Não foi possível instalar na Shopify.');
      } finally {
        btn.disabled = false;
      }
      return;
    }
    if (acao === 'apagar') {
      if (!confirm('Remover este site do rastreamento?')) return;
      try {
        await apiRequest(`/integrations/tracker/sites/${encodeURIComponent(id)}`, { method: 'DELETE' });
        delete detalhes[id];
        delete avisos[id];
        if (siteId === id) siteId = '';
        await carregar();
        onChange?.();
      } catch (err) {
        showToast(err.message || 'Não foi possível remover.');
      }
      return;
    }
    if (acao !== 'testar' && acao !== 'validar') return;
    btn.disabled = true;
    try {
      if (acao === 'testar') {
        const data = await apiRequest(`/integrations/tracker/sites/${encodeURIComponent(id)}/test`, { method: 'POST', body: '{}' });
        const n = data?.data?.events_received ?? 0;
        avisos[id] = `Facebook recebeu o teste (${n}). Confira em Testar eventos com o código salvo.`;
      } else {
        await validar(id);
      }
      onChange?.();
    } catch (err) {
      showToast(err.message || 'Não foi possível concluir.');
    } finally {
      btn.disabled = false;
    }
  });
  root.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-tracker="criar"], [data-tracker="pixel"], [data-tracker="dominio"], [data-tracker="tiktok"]');
    if (!form) return;
    event.preventDefault();
    const data = Object.fromEntries(new FormData(form).entries());
    const submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;
    try {
      if (form.dataset.tracker === 'criar') {
        const escolhida = String(data.lojaId || '').trim();
        delete data.lojaId;
        const res = await apiRequest('/integrations/tracker/sites', { method: 'POST', body: JSON.stringify(data) });
        siteId = res?.data?.site?.id || siteId;
        criarAberto = false;
        aba = 'utms';
        opcao = 'script';
        if (escolhida && siteId) {
          lojaId = escolhida;
          const inst = await apiRequest(`/integrations/tracker/sites/${encodeURIComponent(siteId)}/shopify`, {
            method: 'POST',
            body: JSON.stringify({ lojaId: escolhida }),
          });
          const info = inst?.data || {};
          showToast(info.checkout ? 'Rastreamento criado e script instalado na Shopify.' : 'Rastreamento criado. Script nos produtos; o checkout pediu reconectar a Shopify.');
        } else {
          showToast('Rastreamento criado. Copie o script na aba UTMs.');
        }
      } else if (form.dataset.tracker === 'dominio') {
        await apiRequest(`/integrations/tracker/sites/${encodeURIComponent(form.dataset.id)}`, {
          method: 'PATCH',
          body: JSON.stringify({ adicionarDominio: data.dominio }),
        });
        showToast('Domínio adicionado.');
      } else if (form.dataset.tracker === 'tiktok') {
        await apiRequest(`/integrations/tracker/sites/${encodeURIComponent(form.dataset.id)}/tiktok`, {
          method: 'PUT',
          body: JSON.stringify(data),
        });
        tiktokAberto = false;
        showToast(String(data.pixelId || '').trim() ? 'Pixel do TikTok salvo.' : 'Pixel do TikTok removido.');
      } else {
        await apiRequest(`/integrations/tracker/sites/${encodeURIComponent(form.dataset.id)}/facebook`, {
          method: 'PUT',
          body: JSON.stringify(data),
        });
        pixelAberto = false;
        showToast('Pixel salvo.');
      }
      await carregar();
      onChange?.();
    } catch (err) {
      showToast(err.message || 'Não foi possível salvar.');
    } finally {
      if (submit) submit.disabled = false;
    }
  });
}
